import Triggers from '../components/Triggers';
import TriggerForm from '../components/TriggerForm';

const TriggersContainer = Triggers;

const TriggerFormContainer = TriggerForm;

export {TriggersContainer, TriggerFormContainer};
